<template>
  <v-card class="pa-1 mb-1 primary darken-2">
    <div class="mt-4" v-for="(property, index2) in showTooltip.items" :key="index2">
      <v-card-title><span><v-icon large> $bovines </v-icon></span>
        <span class="pl-3 text-title">
          {{ property.value.toLocaleString("pt-BR",
            {
              maximumFractionDigits: 1
            }) }}</span>
        <span class="text-subtitle pl-2">Cabeças</span>
      </v-card-title>

      <v-card-text>
        <span class="text-subtitle">
          {{ ((property.value * 100) / 8958665).toFixed(2) }}% do
          rebanho do estado</span>
      </v-card-text>
    </div>
  </v-card>
</template>




<script>
export default {
  name: "TooltipBovines",
  props: ["tooltipParams", "showTooltip"],
  data: () => ({}),
};
</script>



<style scoped>
.text-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 23.4286px;
  line-height: 31px;
}

.text-subtitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
}
</style>